


























import { Vue, Component, Prop } from 'vue-property-decorator';

import { dateOfYearFormattedWithMonthName } from '~/utils/date.js';

@Component
export default class DatesRanges extends Vue {
  @Prop(Object) dates: {};

  dateOfYearFormattedWithMonthName = dateOfYearFormattedWithMonthName;

  /* We add translated days of the event depending of event available datas */
  populateDaysDatas (days: {[key: string]: boolean }) {
    const dates: string = `${days.sunday ? this.$t('datesRanges.sunday') : ''}
      ${days.monday ? this.$t('datesRanges.monday') : ''}
      ${days.tuesday ? this.$t('datesRanges.tuesday') : ''}
      ${days.wednesday ? this.$t('datesRanges.wednesday') : ''}
      ${days.thursday ? this.$t('datesRanges.thursday') : ''}
      ${days.friday ? this.$t('datesRanges.friday') : ''}
      ${days.saturday ? this.$t('datesRanges.saturday') : ''}`;

    return dates.replace(/,\s*$/, "");
  }
}
